<div id="error-page" class="flex-container">
  <div id="meta">
    <i class="icon-nimbus-font-light icon-nimbus-times top-right-close" (click)="close()"></i>
    <div class="details">
      <span class="top-message">{{ errorService.topMessage | translate }}</span>
    </div>
    <div class="separator"></div>
    <div class="details">
      <span>{{ errorService.bottomMessage | translate }}</span>
    </div>
    @if (errorService.link) {
      <div class="details">
        <button class="outline icon" (click)="copyLink()" nimbusPrimaryIconButton>
          <i [nimbusIcon]="ICONS.COPY" iconWeight="regular"> </i>
        </button>
      </div>
    }
  </div>
</div>
